import { render, staticRenderFns } from "./AddCardButton.vue?vue&type=template&id=84692920&scoped=true&"
import script from "./AddCardButton.vue?vue&type=script&lang=js&"
export * from "./AddCardButton.vue?vue&type=script&lang=js&"
import style0 from "./AddCardButton.vue?vue&type=style&index=0&id=84692920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84692920",
  null
  
)

export default component.exports